import { Timestamp } from "api/firebase";
import { AttachmentFile, RawAttachmentFile } from "./attachmentFile";

export enum OrderReviewStatus {
  waitingForApproval = "waitingForApproval",
  approved = "approved",
  rejected = "rejected",
}
export enum OrderReviewType {
  any = "any",
}

export type OrderSingleApproved = {
  type: OrderReviewType.any;
  status: OrderReviewStatus.approved;
  reviewer: {
    id: string;
    comment?: string;
    attachments?: AttachmentFile[];
  };
  createdAt: Timestamp;
};
export type OrderSingleRejected = {
  type: OrderReviewType.any;
  status: OrderReviewStatus.rejected;
  reviewer: {
    id: string;
    comment: string;
    attachments?: AttachmentFile[];
  };
  createdAt: Timestamp;
};
type OrderSingleWaitingForApproval = {
  type: OrderReviewType.any;
  status: OrderReviewStatus.waitingForApproval;
};
type OrderAnyReview =
  | OrderSingleApproved
  | OrderSingleRejected
  | OrderSingleWaitingForApproval;

type OrderReview = OrderAnyReview;

export const STRIPE_ID_REJECTION = "stripe";

export type CreatedOrderReview = {
  type: OrderReviewType;
  status: OrderReviewStatus;
  comment?: string;
  attachments?: RawAttachmentFile[];
};

export default OrderReview;
